import React from 'react'
import PropTypes from 'prop-types'
import Router from 'next/router'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import env from 'config/env'
import UrlUtils from 'lib/utils/url'
import VideoPlayer from 'components/video-player'
import ResponsiveImage from 'components/images/responsive-image'
import Button from 'components/common/button'
import { BUTTON_TYPES } from 'constants/button'
import BackdropModal from 'components/portal/backdrop-modal'
import ShopTheLook from 'components/shared/shop-the-look'
import styles from './style.scss'

class LookbookContentItem extends React.PureComponent {
  constructor(props) {
    super(props)

    const { isPhone, isTwoContents, item, lookbook } = props
    const { image, products } = item
    const { id_lookbook, id_category } = lookbook
    this.state = { showShopTheLookModal: false }
    this.defaultMarginTop = '0'
    this.shopTheLookData = {
      refType: 'lookbook_shop_look',
      refId: id_lookbook,
      isLandscape: !!item?.is_landscape,
      products,
      image,
      id_category,
    }

    if (item) {
      this.setContentWrapperStyles(item, isPhone, isTwoContents)
      this.setShopBtnStyles(item)
      this.setWrapperStyles(item)
      this.setImgStyles(item)
    }
  }

  setContentWrapperStyles(item, isPhone, isTwoContents) {
    let contentValign = 'flex-start'
    let contentHalign = 'flex-start'

    if (item.valign === 'middle') {
      contentValign = 'center'
    } else if (item.valign === 'bottom') {
      contentValign = 'flex-end'
    }

    if (item.halign === 'center') {
      contentHalign = 'center'
    } else if (item.halign === 'right') {
      contentHalign = 'flex-end'
    }

    this.contentWrapperStyles = {
      // In the case of video, the margin needs to be applied from the container
      marginTop: item.video ? item.padding_top || this.defaultMarginTop : null,
      justifyContent: isPhone ? null : contentValign,
      alignItems: isPhone ? null : contentHalign,
      minWidth: !isPhone && isTwoContents ? '50%' : null,
    }
  }

  setShopBtnStyles(item) {
    const { isPhone } = this.props

    if (!isPhone) {
      this.shopBtnStyles = {
        // For phone the with of the btn will always be 100% (which is the default in CSS)
        width: item.image_size,
        marginRight: item.padding_right || '0',
        marginLeft: item.padding_left || '0',
        color: 'white!important',
      }
    } else {
      this.shopBtnStyles = {
        color: 'white!important',
      }
    }
  }

  setWrapperStyles(item) {
    this.wrapperStyles = item.halign ? { textAlign: item.halign } : null
  }

  setImgStyles(item) {
    const { isPhone } = this.props
    let imageMarginTop = '0'
    let imageMarginRight = '0'
    let imageMarginBottom = '0'
    let imageMarginLeft = '0'

    // For video, we use margin-top on the container element
    if (!item.video && !isPhone) {
      imageMarginRight = item.padding_right || '0'
      imageMarginBottom = item.padding_bottom || '0'
      imageMarginLeft = item.padding_left || '0'
    }

    imageMarginTop = item.padding_top || this.defaultMarginTop

    this.imgStyles = {
      margin: `${imageMarginTop} ${imageMarginRight} ${imageMarginBottom} ${imageMarginLeft}`,
      width: item[`image_size${isPhone ? '_mobile' : ''}`],
    }
  }

  toggleShowShopTheLookModal = (e) => {
    if (e?.preventDefault) {
      e.preventDefault()
    }

    const { showShopTheLookModal } = this.state

    if (showShopTheLookModal) {
      UrlUtils.shallowPushHash(Router, 'content')
    } else {
      // remove hash
    }

    this.setState({ showShopTheLookModal: !showShopTheLookModal })
  }

  getImageUrl = (imageId) => `${env.IMG_HOST}img/lookbooks/${imageId}.jpg`

  renderImage(imageId) {
    const { isPhone, isTwoContents } = this.props

    return (
      <ResponsiveImage
        alt="lookbook-img"
        imgRatio={!isPhone && !isTwoContents ? 0.666428571 : 1}
        imgStyle={this.imgStyles}
        src={this.getImageUrl(imageId)}
        style={this.wrapperStyles}
      />
    )
  }

  renderVideo(coverId) {
    const { item: { youtube_url: youtube, full_video } = {}, isPhone } =
      this.props

    if (youtube) {
      return (
        <div className="lb-content__youtube-wrapper">
          <iframe
            title="Youtube Video"
            className="lb-content__youtube-iframe"
            src={`https://www.youtube.com/embed/${youtube}?loop=1&playlist=${youtube}`}
            allowFullScreen
            frameBorder="0"
          />
        </div>
      )
    }

    return (
      <VideoPlayer
        className={isPhone ? 'full-width' : ''}
        cover={this.getImageUrl(coverId)}
        fullscreenOnPlay={isPhone}
        hideControls={isPhone}
        loop
        muted={false}
        source={full_video}
        wrapperStyles={this.imgStyles}
      />
    )
  }

  render() {
    const { isPhone, item, t } = this.props
    const { showShopTheLookModal } = this.state
    const externalLinkUrl = item.external_link_url
    const externalLinkTitle = item.external_link_title
    const isShowCta = Boolean(item.hide_shop_this_look === 0)
    const isExternalLinkButton = Boolean(
      item.is_external_link && externalLinkUrl,
    )

    return (
      <div className="lb-content__wrapper" style={this.contentWrapperStyles}>
        <style jsx>{styles}</style>
        {item.image
          ? this.renderImage(item.image)
          : this.renderVideo(item.video_poster)}
        {isShowCta && (
          <div
            className="lb-content__btn-wrapper"
            style={!isPhone && !item.video ? this.wrapperStyles : null}
          >
            {isExternalLinkButton ? (
              <div data-cy="lookbook-external-link-button">
                <Button
                  style={this.shopBtnStyles}
                  className="lb-content__btn"
                  link={externalLinkUrl}
                  aProps={{ href: externalLinkUrl }}
                  target="_blank"
                  type={BUTTON_TYPES.primary}
                >
                  {externalLinkTitle ?? t('Shop this look')}
                </Button>
              </div>
            ) : (
              <div data-cy="lookbook-content-button">
                <Button
                  style={this.shopBtnStyles}
                  className="lb-content__btn"
                  type={BUTTON_TYPES.primary}
                  onClick={this.toggleShowShopTheLookModal}
                >
                  {t('Shop this look')}
                </Button>
              </div>
            )}
          </div>
        )}
        <BackdropModal
          onBackdropClick={this.toggleShowShopTheLookModal}
          isOpen={showShopTheLookModal}
        >
          <ShopTheLook
            close={this.toggleShowShopTheLookModal}
            data={this.shopTheLookData}
          />
        </BackdropModal>
      </div>
    )
  }
}

LookbookContentItem.defaultProps = {
  isTwoContents: false,
  lookbook: undefined,
}

LookbookContentItem.propTypes = {
  isPhone: PropTypes.bool.isRequired,
  isTwoContents: PropTypes.bool,
  item: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.shape({})),
    image: PropTypes.string,
    is_landscape: PropTypes.bool,
    video_poster: PropTypes.string,
    video: PropTypes.string,
    hide_shop_this_look: PropTypes.number,
    youtube_url: PropTypes.string,
    is_external_link: PropTypes.bool,
    external_link_url: PropTypes.string,
    external_link_title: PropTypes.string,
  }).isRequired,
  lookbook: PropTypes.shape({
    id: PropTypes.string,
    id_lookbook: PropTypes.string,
    id_category: PropTypes.number,
    banner: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  t: PropTypes.func.isRequired,
}

const Extended = translate('global')(LookbookContentItem)

export default connect((state) => ({
  isPhone: state.device.isPhone,
  lookbook: state.lookbook.payload,
}))(Extended)
